<badge icon="flow-children" [reversed]="true">
  {{ passed }} / <b>{{ all }}</b>
</badge>
